import {
  getBookClubCheckoutDispatchInfo,
  shouldShowStaticSubscriptionPrice,
  SubscriptionProduct,
} from "@cappelendamm/e-commerce-services";
import { useFormContext } from "react-hook-form";
import { CheckoutForm } from "@/checkout/types";
import { Typography } from "@cappelendamm/design-system/react";

export type SubscriptionOrderProps = {
  subscription: SubscriptionProduct;
};

export const SubscriptionOrder = ({ subscription }: SubscriptionOrderProps) => {
  const { register } = useFormContext<CheckoutForm>();
  const shouldShowPrice = shouldShowStaticSubscriptionPrice(subscription.type);
  const resolvedRecurringPrice =
    subscription.recurringPrice?.price ?? subscription.signUpPrice?.price ?? 0;

  return (
    <>
      <div className="col-span-12 mt-8 mb-4 w-full space-y-4 text-center">
        <Typography as="h1" variant="title-xl">
          {subscription.isBookClub
            ? "Fullfør din bestilling"
            : subscription.externalName}
        </Typography>

        <SubscriptionOfferMessage
          subscription={subscription}
          shouldShowPrice={shouldShowPrice}
          resolvedRecurringPrice={resolvedRecurringPrice}
        />
      </div>

      <input {...register(`subscription.sku`)} hidden />
      <input {...register(`subscription.planIdentifier`)} hidden />
    </>
  );
};

type SubscriptionOfferMessageProps = SubscriptionOrderProps & {
  shouldShowPrice: boolean;
  resolvedRecurringPrice: number;
};

const SubscriptionOfferMessage = ({
  subscription,
  shouldShowPrice,
  resolvedRecurringPrice,
}: SubscriptionOfferMessageProps) => {
  const isCampaignBooksAvailable =
    subscription.campaignBooks && subscription.campaignBooks.length > 0;

  if (isCampaignBooksAvailable) {
    return (
      <Typography variant="body-base" className="font-semilight">
        Få de første {subscription.campaignBooks.length} bøkene i serien gratis.
        Deretter {resolvedRecurringPrice},– pr. bok.
      </Typography>
    );
  }

  if (subscription.isBookClub) {
    return (
      <div className="flex flex-col items-center gap-1.5 text-center">
        <Typography variant="body-base" className="font-semilight">
          Du blir nå medlem av {subscription.clubCode?.key}. Vi håper
          medlemsskapet vil gi mange gode lesestunder.
        </Typography>
      </div>
    );
  }

  return (
    <Typography variant="body-base" className="font-semilight">
      {shouldShowPrice
        ? `Abonnement til ${resolvedRecurringPrice},– pr. bok${subscription.initialPrice?.price === 0 && subscription.isSeries ? ". Få bok 1 gratis!" : ""}`
        : ""}
    </Typography>
  );
};
